import { ButtonState } from "./button-state";
class KeyboardSingleton {
  private keyStates: ButtonState[] = [];

  constructor() {
    for (let i = 0; i < 256; i++) {
      this.keyStates[i] = new ButtonState();
    }

    document.addEventListener('keyup', (event) => this.handleKeyUp(event));
    document.addEventListener('keydown', (event) => this.handleKeyDown(event));
  }

  public reset(): void {
    for (let i = 0; i < 256; i++) {
      this.keyStates[i].pressed = false;
    }
  }

  public isDown(keyCode: number): boolean {
    return this.keyStates[keyCode].down;
  }

  public isPressed(keyCode: number): boolean {
    return this.keyStates[keyCode].pressed;
  }

  private handleKeyUp(event: KeyboardEvent): void {
    if (this.keyStates[event.keyCode]) {
      this.keyStates[event.keyCode].down = false;
    }
  }

  private handleKeyDown(event: KeyboardEvent): void {
    if (this.keyStates[event.keyCode]) {
      this.keyStates[event.keyCode].pressed = true;
      this.keyStates[event.keyCode].down = true;
    }
  }
}

export const Keyboard = new KeyboardSingleton();
